/* eslint-disable no-undef */
const base =
	typeof window !== 'undefined' && window.PUBLIC_URL
		? window.PUBLIC_URL
		: '/mw_v2/search/build/';

__webpack_public_path__ = base.endsWith('/') ? base : base + '/';
